export default "__VITE_ASSET__DjsrZ8E6__"